module.exports = __webpack_public_path__ + "img/265.d0484d4f.jpg";